import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CvConfigurationService } from '../services/cv-configuration.service';

@Component({
    selector: 'cv-loader',
    templateUrl: './cv-loader.component.html',
    styleUrls: ['./cv-loader.component.scss'],
})
export class CvLoaderComponent implements OnInit, OnChanges, OnDestroy {
    @Input() size: 'small' | 'medium' | 'large' = 'medium';
    @Input() overlay = false;
    @Input() loaderType: 'auto' | 'cxone' | 'clearview' = 'auto';
    @Input() isFullScreen = true;
    /** Only applies when loader type is cxone or auto determines it is cxone (through the configuration service) */
    @Input() cxoneIsSpinner = false;

    public sizePixels = 90;
    public sizeClass = "medium";

    constructor(
        protected config: CvConfigurationService,
    ) {

    }

    ngOnDestroy() {
    }

    getLoaderType(): 'cxone'|'clearview' {
        return 'clearview';
    }

    ngOnInit(): void {
        this.updateSize(this.size);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.size?.currentValue) {
            this.updateSize(changes.size.currentValue);
        }
    }

    updateSize(size: string) {
        switch (size) {
            case 'small':
                this.sizePixels = 24;
                this.sizeClass = 'small';
                break;
            case 'large':
                this.sizePixels = 200;
                this.sizeClass = 'large';
                break;
            case 'medium':
            default:
                this.sizePixels = 90;
                this.sizeClass = 'medium';
                break;
        }
    }
}
